import React from "react"
import "./TopPick.css"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"

const MiniSlot = props => (
  <div className="MiniSlot">
    <h3 className="MiniSlot-Title">{props.title}</h3>
    <a className="MiniSlot-Button" href="/">
      <ChevronRightIcon /> See deal
    </a>
  </div>
)

export default MiniSlot